import { gql } from 'graphql.macro';
import { useMutation } from '@apollo/client';

const SUBMIT_ANSWERS_MUTATION = gql`
  mutation submitQuestionnaireAnswers($answers: [QuestionnaireAnswerInput!]) {
    submitQuestionnaireAnswers(answers: $answers) {
      questionSlug
    }
  }
`;

const useSubmitQuestionnaireAnswers = () => {
  const [mutate, { loading }] = useMutation(SUBMIT_ANSWERS_MUTATION);
  const submit = (variables) => {
    return mutate({ variables });
  };
  return { submit, loading };
};

export default useSubmitQuestionnaireAnswers;
